import React from 'react';
import styled from 'styled-components';
import BirthDataForm from './BirthDataForm';

const Grid = styled.div`
  display:grid;grid-template-columns:1fr 1fr;gap:${p => p.theme.spacing[5]}px;
  @media(max-width:${p => p.theme.breakpoints.desktop}px){grid-template-columns:1fr;}
`;
const PersonCard = styled.div`
  border-top:4px solid ${p => p.$color || p.theme.colors.primary};
  background:${p => p.theme.colors.surface};
  border-radius:${p => p.theme.radius.lg}px;
  padding:${p => p.theme.spacing[5]}px;
  box-shadow:${p => p.theme.shadow.card};
`;
const PersonLabel = styled.h3`
  font-size:${p => p.theme.typography.sizes.md};
  margin:0 0 ${p => p.theme.spacing[4]}px;
  font-weight:${p => p.theme.typography.weights.semibold};
  color:${p => p.$color || p.theme.colors.text.primary};
`;
const SubmitButton = styled.button`
  width:100%;padding:14px;margin-top:${p => p.theme.spacing[5]}px;
  border:none;border-radius:${p => p.theme.radius.md}px;
  background:${p => p.theme.colors.primary};color:${p => p.theme.colors.surface};
  font-size:${p => p.theme.typography.sizes.md};
  font-weight:${p => p.theme.typography.weights.semibold};
  cursor:pointer;
  &:hover{background:#5a52d5;}
  &:disabled{opacity:0.6;cursor:not-allowed;}
`;
const ErrorBox = styled.div`
  background:${p => p.theme.colors.error.bg};
  color:${p => p.theme.colors.error.text};
  border-radius:${p => p.theme.radius.md}px;
  padding:${p => p.theme.spacing[3]}px ${p => p.theme.spacing[4]}px;
  margin-top:${p => p.theme.spacing[3]}px;
`;

export default function MatchingForm({
  person1Label = 'Person 1', person2Label = 'Person 2',
  person1Color = '#e91e63', person2Color = '#2196f3',
  fields = ['name', 'dob', 'time', 'place'],
  person1Values, person2Values,
  onPerson1Change, onPerson2Change,
  onSubmit, submitLabel = 'Calculate', loading = false,
  error = null, pageName, lang = 'en',
}) {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSubmit) onSubmit(person1Values, person2Values);
  };

  return (
    <form onSubmit={handleSubmit}>
      <Grid>
        <PersonCard $color={person1Color}>
          <PersonLabel $color={person1Color}>{person1Label}</PersonLabel>
          <BirthDataForm
            fields={fields}
            values={person1Values}
            onChange={onPerson1Change}
            onSubmit={() => {}}
            showSubmit={false}
            pageName={`${pageName}_person1`}
            lang={lang}
            loading={loading}
          />
        </PersonCard>
        <PersonCard $color={person2Color}>
          <PersonLabel $color={person2Color}>{person2Label}</PersonLabel>
          <BirthDataForm
            fields={fields}
            values={person2Values}
            onChange={onPerson2Change}
            onSubmit={() => {}}
            showSubmit={false}
            pageName={`${pageName}_person2`}
            lang={lang}
            loading={loading}
          />
        </PersonCard>
      </Grid>
      <SubmitButton type="submit" disabled={loading}>
        {loading ? 'Computing...' : submitLabel}
      </SubmitButton>
      {error && <ErrorBox>{error}</ErrorBox>}
    </form>
  );
}
